// The website chat: /support-embed runs inside an iframe on eventlive.pro and evt.live and
// talks to the host page with postMessage. Only listed parent origins are answered.
import { supportEmbedParents } from "./config";
const { allowedParent } = require("./message.cjs");
const TYPE = "eventlive-support";
export function embedParent() {
  if (typeof window === "undefined" || window.parent === window) return null;
  return allowedParent(
    new URLSearchParams(window.location.search).get("parent"),
    supportEmbedParents
  );
}
export function postToParent(parent, action, data = {}) {
  if (parent) window.parent.postMessage({ type: TYPE, action, ...data }, parent);
}
export function onParentMessage(parent, handler) {
  if (!parent) return () => {};
  const listener = (event) => {
    if (
      event.origin !== parent ||
      event.source !== window.parent ||
      event.data?.type !== TYPE
    )
      return;
    handler(event.data);
  };
  window.addEventListener("message", listener);
  return () => window.removeEventListener("message", listener);
}
